export default import.meta.ROLLDOWN_FILE_URL_JebV1QAMMrxp2AO26tQsjg